import { formatDateOrDash, formatDateTimeOrDash } from '#/utils/date';
import { formatDisplayAmount } from '#/utils/formatNumber';

import { MISC_PURCHASE_ORDER_TAX_TYPE_OPTIONS } from '../schemas/miscPurchaseOrderSchema';

function displayOrDash(value) {
  if (value == null || value === '') {
    return '—';
  }
  return value;
}

function formatLookupLabel(lookup) {
  if (!lookup) {
    return '—';
  }
  const label = [lookup.code, lookup.name].filter(Boolean).join(' ');
  return label || '—';
}

function formatTaxTypeLabel(taxType) {
  if (!taxType) {
    return '—';
  }
  return MISC_PURCHASE_ORDER_TAX_TYPE_OPTIONS.find((option) => option.value === taxType)?.label
    ?? taxType;
}

/**
 * 非庫存採購單 MainInfoCard meta（對齊物料採購單 mapPurchaseOrderMeta）。
 * 金額只讀 `amountSummary`（BE 為唯一 authority）。
 */
export function mapMiscPurchaseOrderMeta(detail) {
  const summary = detail?.amountSummary;
  const hasAmount = Boolean(summary)
    && (
      summary.subtotalAmount != null
      || summary.taxAmount != null
      || summary.totalAmount != null
    );
  const history = detail?.history;

  return {
    code: detail?.purchaseOrderNo || '-',
    status: detail?.status || '',
    supplierName: displayOrDash(detail?.supplierName),
    createDate: formatDateTimeOrDash(detail?.record?.createdAt),
    reviseDate: formatDateTimeOrDash(detail?.record?.updatedAt),
    submittedDate: formatDateTimeOrDash(history?.submittedAt),
    approvedDate: formatDateTimeOrDash(history?.approvedAt),
    closeDate: formatDateTimeOrDash(history?.closedAt),
    purchaseOrderDate: formatDateOrDash(detail?.purchaseOrderDate),
    paymentTerm: formatLookupLabel(detail?.paymentTerm),
    currency: displayOrDash(detail?.currencyCode || detail?.currency?.code),
    exchangeRate: detail?.exchangeRate == null || detail.exchangeRate === ''
      ? '未設定'
      : String(detail.exchangeRate),
    taxType: formatTaxTypeLabel(summary?.taxType),
    hasAmount,
    subtotalAmount: formatDisplayAmount(summary?.subtotalAmount),
    taxAmount: formatDisplayAmount(summary?.taxAmount),
    totalAmount: formatDisplayAmount(summary?.totalAmount),
    issueReason: detail?.issueReason ?? '',
    remark: detail?.remark ?? '',
    rejectReason: history?.rejectReason ?? '',
    closeReason: history?.closeReason ?? '',
    terminateDate: formatDateTimeOrDash(history?.terminatedAt),
    terminateReason: history?.terminateReason ?? '',
  };
}

export { displayOrDash };
